import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";

type ChallengeSuccessModalProps = {
  visible: boolean;
  message: string;
  confirmText?: string;
  onConfirm: () => void;
};

const ChallengeSuccessModal: React.FC<ChallengeSuccessModalProps> = ({
  visible,
  message,
  confirmText = "OKAY",
  onConfirm,
}) => {
  if (!visible) {
    return null;
  }

  const modalRoot = document.getElementById("modal-root") || document.body;

  return createPortal(
    <div className="ModalOverlay alert-modal-overlay" onClick={onConfirm}>
      <div
        className="alert-modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <h2 className="alert-modal-title">
            <div className="justify-center flex">
                <img src={require("../assets/woohoo.png")} alt="" className="alert-modal-title-image"/>
            </div>
            
        </h2>
        <p className="alert-modal-message">{message}</p>
        <img src={require("../assets/model_success.png")} alt="" className="alert-modal-success-image"/>
        <button type="button" className="alert-modal-button" onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </div>,
    modalRoot
  );
};

export default ChallengeSuccessModal;